import React, { useState } from "react";
import "./nsat.css";
import LogoContact from "../logoContact/logoContact";
import Newnavbar from "../newNavbar/Newnavbar";
import Footer from "../footer/Footer";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { FaWhatsapp } from "react-icons/fa";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import Newenqire from "../Enquire Form/Newenqire";

import Carousel from "react-bootstrap/Carousel";

import ananteng from "../../Assets/about/anaNT 2025 (2013 x 1256 px) Eng.jpg";
// import nsat from "../../Assets/about/NSAT.png"
import nsat from "../../Assets/about/nsat_1.png";
import anantmarathi from "../../Assets/about/anaNT 2025 (2013 x 1256 px) Marathi.jpg";
import { Helmet } from "react-helmet";

function Nsat() {
  const sliderSettings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 560, // Adjust this breakpoint as needed
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 840, // Adjust this breakpoint as needed
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1200, // Adjust this breakpoint as needed
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const navigate = useNavigate();


  const submitdata = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    if (name.length <= 3 || mobile.length <= 10) {
      alert("Please fill the form correctly");
      return; // Stop if validation fails
    }

    // Build the mailto link
    const mailtoLink = `mailto:enquiry@nayakstutorials.com
    ?subject=New Enquiry from Website
    &body=Name: ${encodeURIComponent(name)}%0A
    Email: ${encodeURIComponent(email)}%0A
    Mobile: ${encodeURIComponent(mobile)}%0A`;

    // Open default mail client
    window.location.href = mailtoLink.replace(/\s+/g, "");

    // (Optional) redirect after mail client opens
    navigate("/thankyou");
  };


  return (
    <>
      <Helmet>
        <title>Nayak's Scholarship & Aptitude Test (NSAT)</title>
        <meta charSet="utf-8" />
        <meta name="title" content="Register for NSAT: Nayak's Scholarship & Aptitude Test" />
        <meta name="description" content="Register for the Nayak's Scholarship & Aptitude Test (NSAT) in Thane! Test your knowledge and win scholarships for our coaching programs. Don't miss out!" />
      </Helmet>
      
      <LogoContact />

      <Newnavbar />

      <div className="Hmaindiv">
        <div className="Hmaininnerdiv">
          <div className="hleft">
            <h2 className="text-center">
              <img
                className="boysnayaklanding"
                src={nsat}
                alt="SSC Top Achievers"
              />
            </h2>
          </div>

          <div className="hrightanant">
            <div className="hrightinner">
              <form className="EnqFormnew" onSubmit={submitdata}>
                <h3>Enquire Now</h3>
                <p>Learn from India's best teachers</p>
                <h5>Enter your Contact Details</h5>

                <div className="mb-3">
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Your Full Name"
                    type="text"
                    className="form-control2"
                    id="recipient-name"
                  />
                </div>

                <div className="mb-3">
                  <input
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Enter Your Mobile Number"
                    type="text"
                    className="form-control2"
                    id="recipient-name"
                  />
                </div>

                <div className="mb-3">
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Your Email Address"
                    type="text"
                    className="form-control2"
                    id="recipient-name"
                  />
                </div>

                <div className="modalBtn">
                  <button type="submit" className="FormSubmit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="secondsection1">
        <h4>About Nayak’s Scholarship cum <br></br>Admission Test (NSAT) 2026</h4>
        <p className="secondsectionP">
          <b>Nayak’s Scholarship Cum Admission Test (NSAT)</b> is a Knowledge
          Test covering <b>X Board Level</b> Science, Math, English, GK &
          Aptitude questions. NSAT helps to identify the potential of a student,
          gives insight, and helps them to take the first steps towards
          achieving their dream success.
        </p>
        <p className="secondsectionP">
          Based on the <b>NSAT</b> Score also, students are given admission to
          our A<b>CE 40 Batch / Pro-Commerce Batch with Class XI-XII.</b>{" "}
        </p>
        <p className="secondsectionP">
          <b>Scholarships of up to 90% </b>are awarded to students based on
          their scores on the NSAT and are applicable as a fee discount for
          students in the <b>ACE 40 Batch</b> (For NEET-UG/IIT-JEE + MHT-CET)
          and <b>Pro-Commerce Batch</b> (For CA, BBA, BFM, Law etc.) with Class
          XI-XII.
        </p>

        <div className="secondsection1">
          <h4>Scholarships</h4>
          <p className="secondsectionP">
            Through the NSAT, students can also earn scholarships up to 90% for
            admission to ACE 40 Batch / Pro-Commerce Batch which is applicable
            to the course fee as fee rebate.
          </p>
        </div>

      </div>
      <div className="Cmaindiv1">
        <div className="Coffermaindiv">
          <div className="Cofferinnerdiv">
            <div className="Coffermainbox">
              <div className="secondsection11">
                <h4>Exam Pattern</h4>
                <p className="secondsectionP">
                  The NSAT consists of multiple-choice questions.
                </p>
              </div>
            </div>
            <div className="Coffermainbox">
              <div className="secondsection1">
                <h4>Eligibility</h4>
                <p className="secondsectionP">
                  10 to 11 moving students / Class 10 passed
                </p>
              </div>
            </div>
            <div className="Coffermainbox">
              <div className="secondsection1">
                <h4>Mode of Test</h4>
                <p className="secondsectionP">Offline (at the Centre).</p>
              </div>
            </div>
            <div className="Coffermainbox">
              <div className="secondsection1">
                <h4>Exam Duration</h4>
                <p className="secondsectionP">60 Minutes</p>
              </div>
            </div>
            <div className="Coffermainbox">
              <div className="secondsection1">
                <h4>Total marks in NSAT exam</h4>
                <p className="secondsectionP">
                  40 questions (Science, Math, English & Aptitude) for 160
                  marks.
                </p>
              </div>
            </div>
            <div className="Coffermainbox">
              <div className="secondsection1">
                <h4>Marking Scheme</h4>
                <p className="secondsectionP">
                  +4 for correct answer, -1 for wrong answer and 0 for no
                  answer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="secondsection1">
        <h4>NSAT 2025 – Qualifying Marks</h4>
        <p className="secondsectionP">
          NSAT does not have any qualifying marks requirements.
        </p>
        <p className="secondsectionP">
          The score of the NSAT is considered for admission to ACE 40 Batch /
          Pro-Commerce Batch at Nayak’s Tutorials.
        </p>
      </div>

      <div className="elevenLastDiv">
        <h3 className="elevenFaq">Frequently Asked Questions (FAQs)</h3>
        <Accordion allowMultipleExpanded={false} allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                1. Can I take admission to Nayak’s Tutorials without NSAT exam?
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              Yes, you can take admission to Nayak’s Tutorials without appearing
              in the NSAT. There are scholarship plans based on past academic
              performance also.
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <Accordion allowMultipleExpanded={false} allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                2. Can I appear on NSAT twice or more?
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              Yes certainly. If you aren’t satisfied with your score you may
              reappear in the next NSAT exam.
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <Accordion allowMultipleExpanded={false} allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                3. What is the fee for NSAT?
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              ₹ 100 (₹ Three Hundred) only.
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <Accordion allowMultipleExpanded={false} allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>4. Date of Exam</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>SUNDAY, 24 August 2025</AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <Accordion allowMultipleExpanded={false} allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                4. How to register for NSAT?
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              Visit your nearest <b>Nayak’s Tutorials</b> Centre in Thane.
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
      <br></br>
      <br></br>

      <a href="https://wa.me/+917710010044" target="_blank">
        <div className="wpicon">
          <FaWhatsapp id="faWp" size={50} color="white" />
        </div>
      </a>

      <div className="newenquirediv">
        <Newenqire />
      </div>

      {/* <Footer /> */}
    </>
  );
}

export default Nsat;
